import React from "react";
import { Box } from "@mui/material";
import { useThemeContext } from "../../../context/ThemeContext";

const LiquidGlassCard = ({ children }) => {
  const { isDark } = useThemeContext();
  return (
    <Box
      sx={{
        p: { xs: 2.5, md: 4 },
        borderRadius: { xs: "16px", md: "20px" },
        background: isDark ? "rgba(255,255,255,0.1)" : "rgba(255,255,255,0.65)",
        backdropFilter: "blur(25px)",
        WebkitBackdropFilter: "blur(25px)",
        border: isDark ? "1px solid rgba(255,255,255,0.2)" : "1px solid rgba(0,0,0,0.08)",
        boxShadow: isDark ? "0 4px 16px 0 rgba(0,0,0,0.3)" : "0 4px 16px 0 rgba(0,0,0,0.08)",
        transition: "background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease",
      }}
    >
      {children}
    </Box>
  );
};

export default LiquidGlassCard;
